<div class="final-factor-container" fxLayout="row">
  <div class="wrapper" fxLayout="column" fxFlex="70">
    <div id="orders-summery" class="final-section">
      <h3 class="title">خلاصه خدمات</h3>
      <div
        class="orders-wrapper"
        *ngIf="payment && payment.orders?.length! > 0"
      >
        <order-review-mode
          *ngFor="let order of payment.orders"
          [orderObject]="order"
        ></order-review-mode>
      </div>

      <div class="warn-block">
        شما میتوانید این سبد خرید را در صفحه
        <a routerLink="/user/my-orders">سفارش‌های من</a> در تب در انتظار پرداخت
        ببینید و آن را بعدا پرداخت کنید
      </div>
    </div>
  </div>

  <shopping-cart-payment-status
    [status]="paymentStatus"
    [transportMethod]="transportMethod"
    (submit)="startPayment()"
    submitTitle="تایید و پرداخت اینترنتی"
    fxFlex="28"
  ></shopping-cart-payment-status>
</div>
